import { PostgrestClient } from "@supabase/postgrest-js";
import { Tenant } from "../types";

export class TenantService {
  private postgrest: PostgrestClient;

  constructor(postgrest: PostgrestClient) {
    this.postgrest = postgrest;
  }

  /**
   * Update tenant information
   */
  async updateTenant(
    tenantId: string,
    updates: {
      tail_number?: string;
      owner_manager?: string;
      aircraft_id?: string;
      type?: string;
      note?: string;
      note_last_updated?: string;
      note_last_updated_by?: string;
      vip_tag_ids?: string[];
    }
  ): Promise<Tenant> {
    const { data, error } = await this.postgrest
      .from("tenant")
      .update(updates)
      .eq("id", tenantId)
      .select()
      .single();

    if (error) {
      throw new Error(`Failed to update tenant: ${error.message}`);
    }

    return data;
  }

  /**
   * Get tenant by ID
   */
  async getTenant(tenantId: string): Promise<Tenant> {
    const { data, error } = await this.postgrest
      .from("tenant")
      .select()
      .eq("id", tenantId)
      .single();

    if (error) {
      throw new Error(`Failed to get tenant: ${error.message}`);
    }

    return data;
  }

  /**
   * Create or update tenant in database
   * Uses upsert to handle both new and existing tenants
   */
  async createTenant(tenant: Tenant): Promise<Tenant> {
    const { data, error } = await this.postgrest
      .from("tenant")
      .upsert({
        id: tenant.id,
        fbo_id: tenant.fbo_id,
        entity_id: tenant.entity_id,
        owner_manager: tenant.owner_manager,
        tail_number: tenant.tail_number,
        type: tenant.type,
        aircraft_id: tenant.aircraft_id,
        note: tenant.note,
        note_last_updated: tenant.note_last_updated,
        note_last_updated_by: tenant.note_last_updated_by,
        vip_tag_ids: tenant.vip_tag_ids ?? [],
      })
      .select()
      .single();

    if (error) {
      throw new Error(`Failed to create tenant: ${error.message}`);
    }

    return data;
  }
}